import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { A11yModule } from '@angular/cdk/a11y';

@Component({
  selector: 'app-info-cv-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatCheckboxModule,
    FormsModule,
    A11yModule,
  ],
  templateUrl: './info-cv-dialog.component.html',
  styleUrls: ['./info-cv-dialog.component.scss'],
})
export class InfoCvDialogComponent {
  constructor(public dialogRef: MatDialogRef<InfoCvDialogComponent>) {}
}
